import styled from 'styled-components';

import { ShowMoreOrLess } from '@telialt/common-show-more-or-less/src';
import { getPurpurBorder, getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';

export const ShowMoreOrLessStyled = styled(ShowMoreOrLess)`
    border-bottom: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray200')};
`;
